import { render, staticRenderFns } from "./TemporalDiscreteGraphWidget.vue?vue&type=template&id=d53051ea&scoped=true"
import script from "./TemporalDiscreteGraphWidget.vue?vue&type=script&lang=js"
export * from "./TemporalDiscreteGraphWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53051ea",
  null
  
)

export default component.exports